import { useQuery } from '@tanstack/react-query';
import { fetchPortTypes } from '../data-provider/port-type';

export const useGetPortTypes = () => {
  return useQuery({
    queryKey: ['port-types-list'],
    queryFn: () => fetchPortTypes(),
    staleTime: Number.POSITIVE_INFINITY,
  });
};
